export const admin = {
  'admin.title': 'Tableau de Bord Admin',
  'admin.subtitle': 'Gérer les subventions, fermes et paramètres système',
  'admin.devEnv': 'Environnement de Développement - Fonctionnalités supplémentaires activées',
  'admin.accessDenied': 'Accès Refusé',
  'admin.loginRequired': 'Vous devez être connecté pour accéder au panneau d\'administration.',
  'admin.permissionDenied': 'Vous n\'avez pas la permission d\'accéder au panneau d\'administration.',
  'admin.onlyAdmins': 'Seuls les administrateurs peuvent accéder à cette section.',
  'admin.devMode': 'Mode développement : L\'accès administrateur est restreint aux emails configurés.',

  // Import Management
  'admin.import.title': 'Importation de Données',
  'admin.import.subtitle': 'Importer des subventions, fermes et candidatures en lot',
  'admin.import.dataType': 'Type de Données',
  'admin.import.file': 'Fichier (CSV, Excel, JSON)',
  'admin.import.selected': 'Sélectionné',
  'admin.import.parsePreview': 'Analyser et Prévisualiser',
  'admin.import.fieldMapping': 'Mappage des Champs',
  'admin.import.fieldMappingDesc': 'Mapper les colonnes de votre fichier aux champs de données canoniques',
  'admin.import.skipField': 'Ignorer ce champ',
  'admin.import.validateData': 'Valider les Données',
  'admin.import.validationResults': 'Résultats de Validation',
  'admin.import.validRecords': 'Enregistrements Valides',
  'admin.import.warnings': 'Avertissements',
  'admin.import.errors': 'Erreurs',
  'admin.import.duplicatesFound': '{count} doublons potentiels trouvés. Vérifier avant d\'importer.',
  'admin.import.issuesFound': 'Problèmes Trouvés:',
  'admin.import.moreIssues': '... et {count} problèmes de plus',
  'admin.import.startOver': 'Recommencer',
  'admin.import.importRecords': 'Importer {count} Enregistrements',
  'admin.import.progress': 'Progression d\'Importation',
  'admin.import.processed': 'Traités',
  'admin.import.success': 'Succès',
  'admin.import.failed': 'Échecs',
  'admin.import.completed': 'Importation terminée avec succès! {count} enregistrements importés.',
  'admin.import.downloadTemplates': 'Télécharger les Modèles',
  'admin.import.history': 'Historique d\'Importation',
  'admin.import.templates': 'Modèles et Documentation',
  'admin.import.historyComingSoon': 'Fonctionnalité d\'historique d\'importation bientôt disponible...',
  'admin.import.templatesComingSoon': 'Télécharger les modèles et voir la documentation...',

  // Validation Messages
  'admin.validation.fileEmpty': 'Le fichier est vide ou n\'a pas pu être analysé',
  'admin.validation.unsupportedFormat': 'Format de fichier non supporté',
  'admin.validation.invalidJSON': 'Format JSON invalide',
  'admin.validation.required': 'Ce champ est requis',
  'admin.validation.invalidType': 'Type de données invalide',
  'admin.validation.duplicateFound': 'Valeur dupliquée trouvée',
  'admin.validation.invalidDate': 'Format de date invalide',
  'admin.validation.invalidNumber': 'Format de nombre invalide',
  'admin.validation.invalidURL': 'Format d\'URL invalide',

  // Toasts
  'admin.toast.importFailed': 'Importation Échouée',
  'admin.toast.validationErrors': 'Erreurs de Validation',
  'admin.toast.validationComplete': 'Validation Complète',
  'admin.toast.recordsReady': '{count} enregistrements prêts à importer',
  'admin.toast.importComplete': 'Importation Complète',
  'admin.toast.recordsImported': '{success} enregistrements importés avec succès. {failed} ont échoué.',
  'admin.toast.unknownError': 'Erreur inconnue survenue',
  'admin.toast.errorsFound': '{count} erreurs trouvées qui doivent être corrigées',

  // Admin Features for Settings Page
  'admin.tierSimulator.title': 'Simulateur de Tiers',
  'admin.tierSimulator.description': 'Tester différents niveaux d\'abonnement (Découvrir, Solo, Pro, Enterprise)',
  'admin.employee.title': 'Tableau de Bord Employé',
  'admin.employee.description': 'Outils de gestion pour les employés et membres de l\'équipe',
  'admin.dataQuality.title': 'Qualité des Données',
  'admin.dataQuality.description': 'Surveiller et améliorer la qualité des données de subventions',
  'admin.panel.title': 'Panneau Admin',
  'admin.panel.description': 'Panneau d\'administration principal et outils de gestion système',
  'admin.devTools.title': 'Outils de Développement',
  'admin.devTools.description': 'Outils de développement et de débogage pour les développeurs',

  // Admin Review Dashboard
  'admin.placeholders.addReviewNotes': 'Ajoutez vos notes de révision...',

  // AI Testing Control
  'admin.placeholders.leaveEmptyForAutoGenerate': 'Laisser vide pour générer automatiquement',

  // Subsidy Document Extractor
  'admin.placeholders.enterPdfUrl': 'Entrez l\'URL du PDF pour tester l\'extraction...',

  // Consultant Verification
  'admin.placeholders.explainRejection': 'Expliquez pourquoi ce profil est rejeté...',

  // AI Field Classifier
  'admin.placeholders.enterFieldName': 'Entrez le nom du champ...',

  // URL Health Dashboard
  'admin.placeholders.searchSubsidiesOrUrls': 'Rechercher des subventions ou des URL...',

  // Admin V2 - Nouveau tableau de bord admin
  'adminV2.title': 'Admin Subvention360',
  'adminV2.signIn.title': 'Accès Admin',
  'adminV2.signIn.subtitle': 'Connectez-vous pour accéder au tableau de bord admin',
  'adminV2.signIn.email': 'Email',
  'adminV2.signIn.password': 'Mot de passe',
  'adminV2.signIn.button': 'Se connecter',
  'adminV2.signIn.signingIn': 'Connexion...',
  'adminV2.signIn.error': 'Email ou mot de passe invalide',
  'adminV2.verifying': 'Vérification de l\'accès admin...',
  'adminV2.redirecting': 'Redirection...',
  'adminV2.logout': 'Déconnexion',

  // Admin V2 Navigation
  'adminV2.nav.kpis': 'KPIs',
  'adminV2.nav.commercial': 'Commercial',
  'adminV2.nav.users': 'Utilisateurs',
  'adminV2.nav.profiles': 'Profils',
  'adminV2.nav.data': 'Données',
  'adminV2.nav.health': 'Santé',
  'adminV2.nav.content': 'Contenu',
  'adminV2.nav.subsidies': 'Subventions',
  'adminV2.nav.blog': 'Blog',

  // Admin V2 Tableau de bord Commercial
  'adminV2.commercial.title': 'Tableau de Bord Commercial',
  'adminV2.commercial.subtitle': 'Entonnoir de conversion & métriques de revenus',
  'adminV2.commercial.loading': 'Chargement des métriques...',
  'adminV2.commercial.error': 'Échec du chargement des analytics',
  'adminV2.commercial.errorHint': 'Assurez-vous que POSTHOG_PERSONAL_API_KEY et POSTHOG_PROJECT_ID sont configurés dans les secrets Supabase.',
  'adminV2.commercial.retry': 'Réessayer',
  'adminV2.commercial.openPostHog': 'Ouvrir PostHog',
  'adminV2.commercial.trialSignups': 'Inscriptions Essai',
  'adminV2.commercial.trialConversion': 'Conversion Essai',
  'adminV2.commercial.standardSignups': 'Inscriptions Standard',
  'adminV2.commercial.overallConversion': 'Conversion Globale',
  'adminV2.commercial.completed': 'terminés',
  'adminV2.commercial.trialToPaid': 'Essai vers payant',
  'adminV2.commercial.onboardingFunnel': 'Entonnoir d\'Onboarding',
  'adminV2.commercial.stepConversion': 'Conversion étape par étape',
  'adminV2.commercial.abandonmentReasons': 'Raisons d\'Abandon',
  'adminV2.commercial.whyDropOff': 'Pourquoi les utilisateurs abandonnent',
  'adminV2.commercial.noFunnelData': 'Aucune donnée d\'entonnoir disponible',
  'adminV2.commercial.noAbandonmentData': 'Aucune donnée d\'abandon',
  'adminV2.commercial.dailyActivity': 'Activité Quotidienne',
  'adminV2.commercial.signupsOverTime': 'Inscriptions au fil du temps',
  'adminV2.commercial.noDailyData': 'Aucune donnée quotidienne disponible',
  'adminV2.commercial.date': 'Date',
  'adminV2.commercial.started': 'Commencés',
  'adminV2.commercial.abandoned': 'Abandonnés',
  'adminV2.commercial.period24h': '24h',
  'adminV2.commercial.period7d': '7 jours',
  'adminV2.commercial.period30d': '30 jours',

  // Admin V2 Commercial - Revenus Stripe
  'adminV2.commercial.revenueMetrics': 'Métriques de Revenus',
  'adminV2.commercial.revenueSubtitle': 'Données de paiement & abonnement Stripe',
  'adminV2.commercial.totalRevenue': 'Revenu Total',
  'adminV2.commercial.balance': 'Solde',
  'adminV2.commercial.pending': 'en attente',
  'adminV2.commercial.customers': 'Clients',
  'adminV2.commercial.invoices': 'Factures Payées',
  'adminV2.commercial.overdue': 'en retard',
  'adminV2.commercial.mrr': 'Revenu Mensuel Récurrent',
  'adminV2.commercial.activeSubscriptions': 'Abonnements Actifs',
  'adminV2.commercial.trialUsers': 'Utilisateurs en Essai',
  'adminV2.commercial.inTrial': 'en essai',
  'adminV2.commercial.churnRate': 'Taux de Désabonnement',
  'adminV2.commercial.thisMonth': 'ce mois',
  'adminV2.commercial.canceledThisMonth': 'annulés ce mois',
  'adminV2.commercial.customersByTier': 'Clients par Niveau',
  'adminV2.commercial.volumeDistribution': 'Répartition par volume',
  'adminV2.commercial.noTierData': 'Aucune donnée de niveau disponible',
  'adminV2.commercial.recentTransactions': 'Transactions Récentes',
  'adminV2.commercial.latestPayments': 'Derniers paiements reçus',
  'adminV2.commercial.noTransactions': 'Aucune transaction récente',
  'adminV2.commercial.stripeNotConfigured': 'Stripe non configuré',
  'adminV2.commercial.stripeHint': 'Assurez-vous que STRIPE_SECRET_KEY est configuré dans les secrets Supabase.',
  'adminV2.commercial.openStripe': 'Ouvrir Stripe',

  // Admin V2 Commercial - Analyse du Trafic
  'adminV2.commercial.trafficAnalytics': 'Analyse du Trafic',
  'adminV2.commercial.trafficSubtitle': 'Pages vues, performance & engagement',
  'adminV2.commercial.pageViews': 'Pages Vues',
  'adminV2.commercial.uniqueUsers': 'utilisateurs uniques',
  'adminV2.commercial.lcp': 'LCP',
  'adminV2.commercial.lcpDesc': 'Largest Contentful Paint',
  'adminV2.commercial.cls': 'CLS',
  'adminV2.commercial.clsDesc': 'Cumulative Layout Shift',
  'adminV2.commercial.inp': 'INP',
  'adminV2.commercial.inpDesc': 'Interaction to Next Paint',
  'adminV2.commercial.topPages': 'Pages Populaires',
  'adminV2.commercial.topPagesSubtitle': 'Pages les plus visitées',
  'adminV2.commercial.views': 'vues',
  'adminV2.commercial.noPageData': 'Aucune donnée de page disponible',
  'adminV2.commercial.good': 'Bon',
  'adminV2.commercial.needsImprovement': 'À améliorer',
  'adminV2.commercial.poor': 'Faible',
  'adminV2.commercial.noData': 'Pas de données',

  // Admin V2 Page Utilisateurs
  'adminV2.users.title': 'Utilisateurs & Abonnements',
  'adminV2.users.subtitle': 'Gérer les utilisateurs et la facturation',
  'adminV2.users.refresh': 'Actualiser',
  'adminV2.users.search': 'Rechercher par email ou organisation...',
  'adminV2.users.totalUsers': 'Total Utilisateurs',
  'adminV2.users.onTrial': 'En Essai',
  'adminV2.users.activePaid': 'Actifs Payants',
  'adminV2.users.pastDue': 'En Retard',
  'adminV2.users.filterAll': 'Tous',
  'adminV2.users.filterTrial': 'Essai',
  'adminV2.users.filterActive': 'Actifs',
  'adminV2.users.filterPastDue': 'En Retard',
  'adminV2.users.email': 'Email',
  'adminV2.users.organization': 'Organisation',
  'adminV2.users.status': 'Statut',
  'adminV2.users.tier': 'Niveau',
  'adminV2.users.joined': 'Inscription',
  'adminV2.users.loading': 'Chargement des utilisateurs...',
  'adminV2.users.noUsers': 'Aucun utilisateur trouvé',

  // Admin V2 Page Profils
  'adminV2.profiles.title': 'Profils Clients',
  'adminV2.profiles.subtitle': 'Gérer les profils & relancer le matching',
  'adminV2.profiles.search': 'Rechercher par entreprise, code NAF, email...',
  'adminV2.profiles.company': 'Entreprise',
  'adminV2.profiles.nafCode': 'Code NAF',
  'adminV2.profiles.department': 'Département',
  'adminV2.profiles.owner': 'Propriétaire',
  'adminV2.profiles.dataQuality': 'Qualité Données',
  'adminV2.profiles.lastMatch': 'Dernier Match',
  'adminV2.profiles.actions': 'Actions',
  'adminV2.profiles.never': 'Jamais',
  'adminV2.profiles.loading': 'Chargement des profils...',
  'adminV2.profiles.noProfiles': 'Aucun profil trouvé',
  'adminV2.profiles.qualityGood': 'Bon',
  'adminV2.profiles.qualityPartial': 'Partiel',
  'adminV2.profiles.qualityPoor': 'Faible',
  'adminV2.profiles.matchingRelaunched': 'Matching relancé',
  'adminV2.profiles.matchingRecalculated': 'Le matching du profil a été recalculé.',
  'adminV2.profiles.matchingError': 'Échec du relancement du matching.',

  // Admin V2 Page Données
  'adminV2.data.title': 'Qualité des Données & Scrapers',
  'adminV2.data.subtitle': 'Surveiller les sources de données et la qualité',
  'adminV2.data.totalSubsidies': 'Total Subventions',
  'adminV2.data.dataCompleteness': 'Complétude des Données',
  'adminV2.data.expiredSubsidies': 'Subventions Expirées',
  'adminV2.data.brokenUrls': 'URLs Cassées',
  'adminV2.data.dataSources': 'Sources de Données',
  'adminV2.data.scraperStatus': 'État des scrapers et contrôles',
  'adminV2.data.lastRun': 'Dernière exécution',
  'adminV2.data.neverRun': 'Jamais exécuté',
  'adminV2.data.records': 'enregistrements',
  'adminV2.data.runNow': 'Exécuter',
  'adminV2.data.failed': 'Échec',
  'adminV2.data.fieldCompleteness': 'Complétude des Champs',
  'adminV2.data.fieldCompletenessDesc': 'Pourcentage de subventions avec chaque champ rempli',
  'adminV2.data.scraperStarted': 'Scraper démarré',
  'adminV2.data.scraperTriggered': 'Le scraper a été lancé.',
  'adminV2.data.scraperError': 'Échec du démarrage du scraper.',

  // Admin V2 Page Santé
  'adminV2.health.title': 'Santé du Système',
  'adminV2.health.lastUpdated': 'Dernière mise à jour',
  'adminV2.health.allOperational': 'Tous les Systèmes Opérationnels',
  'adminV2.health.someDegraded': 'Certains Systèmes Dégradés',
  'adminV2.health.issuesDetected': 'Problèmes Détectés',
  'adminV2.health.servicesHealthy': 'sur {total} services en bonne santé',
  'adminV2.health.subsidies': 'Subventions',
  'adminV2.health.profiles': 'Profils',
  'adminV2.health.uptime': 'Disponibilité',
  'adminV2.health.activeUsers': 'Utilisateurs Actifs',
  'adminV2.health.services': 'Services',
  'adminV2.health.serviceStatus': 'État individuel des services',
  'adminV2.health.latency': 'Latence',
  'adminV2.health.healthy': 'Sain',
  'adminV2.health.degraded': 'Dégradé',
  'adminV2.health.down': 'Hors ligne',
  'adminV2.health.quickActions': 'Actions Rapides',
  'adminV2.health.commonTasks': 'Tâches administratives courantes',
  'adminV2.health.supabaseDashboard': 'Dashboard Supabase',
  'adminV2.health.vercelDashboard': 'Dashboard Vercel',
  'adminV2.health.postHog': 'PostHog',

  // Admin V2 Page Contenu - Orchestrateur de Posts LinkedIn
  'adminV2.content.title': 'Orchestrateur de Posts LinkedIn',
  'adminV2.content.subtitle': 'Générer et gérer les posts marketing',
  'adminV2.content.totalPosts': 'Total des Posts',
  'adminV2.content.drafts': 'Brouillons',
  'adminV2.content.published': 'Publiés',
  'adminV2.content.publishedThisMonth': 'Publiés ce Mois',
  'adminV2.content.generateSubsidy': 'Générer Post Subvention',
  'adminV2.content.generateFeature': 'Générer Post Fonctionnalité',
  'adminV2.content.selectSubsidy': 'Sélectionner une Subvention',
  'adminV2.content.selectFeature': 'Sélectionner une Fonctionnalité',
  'adminV2.content.tone': 'Ton',
  'adminV2.content.toneEngaging': 'Engageant',
  'adminV2.content.toneProfessional': 'Professionnel',
  'adminV2.content.toneEducational': 'Éducatif',
  'adminV2.content.generate': 'Générer avec l\'IA',
  'adminV2.content.generating': 'Génération en cours...',
  'adminV2.content.regenerate': 'Régénérer',
  'adminV2.content.copyToClipboard': 'Copier dans le presse-papiers',
  'adminV2.content.copied': 'Copié !',
  'adminV2.content.markPublished': 'Marquer comme publié',
  'adminV2.content.delete': 'Supprimer',
  'adminV2.content.view': 'Voir',
  'adminV2.content.status.draft': 'Brouillon',
  'adminV2.content.status.published': 'Publié',
  'adminV2.content.status.archived': 'Archivé',
  'adminV2.content.type.subsidy': 'Mise en avant Subvention',
  'adminV2.content.type.feature': 'Fonctionnalité Plateforme',
  'adminV2.content.noPostsYet': 'Aucun post encore. Générez le premier !',
  'adminV2.content.filterByType': 'Filtrer par type',
  'adminV2.content.filterByStatus': 'Filtrer par statut',
  'adminV2.content.allTypes': 'Tous les types',
  'adminV2.content.allStatuses': 'Tous les statuts',
  'adminV2.content.refresh': 'Actualiser',
  'adminV2.content.generatedPosts': 'Posts Générés',

} as const;